var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.model)?_c('div',[_c('div',{staticClass:"list-notice"},[_c('figure',{staticClass:"image"},[_c('router-link',{staticClass:"anoticia",attrs:{"to":{ name: 'public.noticia', params: {code: _vm.model.idnoticia } }}},[_c('img',{staticClass:"imgnoticia",attrs:{"src":_vm.obtenerUrl(_vm.model.imagen),"alt":"Placeholder image"}})])],1)])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f81d4da6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/TheNoticeItem.vue
// module id = 217
// module chunks = 20